import {$controller} from "rapid/index";

export default class Controller extends $controller {

    constructor($injector) {
        "ngInject";
        super($injector);
    }
}


// WEBPACK FOOTER //
// ./sources/components/configurations/configurations.controller.js